import * as React from 'react';
import { View } from '@react-pdf/renderer';
import { styles } from './styles';

const Divider = () => <View style={styles.divider} />;

export default Divider;
